<template>
  <div v-if="!isSupport" class="full-width full-height position-relative">
    <v-overlay :value="!isSupport">
      <div class="not-support-map">
        <p class="">
          Trình duyệt của bạn không hỗ trợ hiển thị bản đồ, vui lòng đổi trình
          duyệt hoặc cập nhật bản mới để xem.
        </p>
      </div>
    </v-overlay>
  </div>
  <div v-else class="map-container mapbox-gl-viewer position-relative">
    <div class="map-viewer">
      <div ref="mapContainer" class="map-content"> </div>

      <portal-target
        class="right-bottom-container"
        multiple
        :name="rightBottomTo"
      />
      <portal-target
        class="left-bottom-container"
        multiple
        :name="leftBottomTo"
      />
      <portal-target class="right-top-container" multiple :name="rightTopTo" />
      <portal-target class="left-top-container" multiple :name="leftTopTo" />
      <draggable-map-contianer
        class="drag-container"
        :isShowSidebar.sync="isShowSidebar"
        :mapId="id"
      />
      <slot v-if="loaded" />
    </div>
  </div>
</template>

<script>
// const DEFAULTOPTION = {
//   center: [105.19084739818732, 15.827971829957548],
//   zoom: 5.297175623863693,
//   maxZoom: 22,
// }
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import DraggableMapContianer from '@components/draggable/draggable-map-contianer.vue'
import { getGlyphs, getSprite } from '@constant'
import bbox from '@turf/bbox'
import { getUUIDv4 } from '@utils'
import { setMap } from './store/store-map'
import { getToken } from '@/src/service/http/auth'
export default {
  components: { DraggableMapContianer },
  props: {
    mapboxAccessToken: {
      type: String,
      default: '',
    },
    initOptions: {
      type: Object,
      default: () => ({
        attributionControl: false,
        zoomControl: false,
      }),
    },
    center: {
      type: Object,
      default: () => ({
        center: [105.19084739818732, 15.827971829957548],
        zoom: 5.297175623863693,
        maxZoom: 22,
      }),
    },
  },

  data() {
    return {
      isShowSidebar: false,
      isSupport: true,
      loaded: false,
      id: getUUIDv4(),
    }
  },
  computed: {
    rightBottomTo() {
      return `${this.id}-bottom-right`
    },
    leftBottomTo() {
      return `${this.id}-bottom-left`
    },
    rightTopTo() {
      return `${this.id}-top-right`
    },
    leftTopTo() {
      return `${this.id}-top-left`
    },
  },
  watch: {
    center: {
      handler(value) {
        if (this.map) {
          this.map.flyTo({
            center: value.center,
            zoom: value.zoom ? value.zoom : 6,
            duration: 800,
          })
        }
      },
      immediate: true,
    },
  },
  provide() {
    return {
      getMap: this.getMap,
      formatCoordinates: this.formatCoordinates,
      mapHandle: {
        fitBounds: this.fitBounds,
      },
      mapId: this.id,
    }
  },

  created() {
    mapboxgl.accessToken = this.mapboxAccessToken
  },

  mounted() {
    this.isSupport = mapboxgl.supported()
    if (this.isSupport) {
      this.$nextTick(() => {
        this.init()
      })
    }
  },

  destroyed() {
    this.destroy()
  },

  methods: {
    fitBounds(value) {
      if (!value || !this.map) return
      let padding = this.isShowSidebar
        ? { top: 50, bottom: 50, left: 450, right: 50 }
        : 20
      if (['Point'].includes(value.type)) {
        this.map.flyTo({
          center: value.coordinates,
          zoom: 15,
          duration: 0,
        })
        this.map.easeTo({
          padding,
        })
        return
      }
      let bboxFil = undefined
      if (value.length == 4) {
        bboxFil = value
      } else {
        bboxFil = this.getBBox(value)
      }
      if (!bboxFil) return

      this.map.fitBounds(bboxFil, {
        padding,
        duration: 0,
      })
    },
    getBBox(feature) {
      if (!feature.type) return
      let bboxFil = undefined
      if (['Feature', 'FeatureCollection'].includes(feature.type)) {
        bboxFil = bbox(feature)
      } else {
        bboxFil = bbox({
          type: 'Feature',
          properties: {},
          geometry: feature,
        })
      }
      return bboxFil
    },
    formatCoordinates(coordinates) {
      return coordinates
    },
    init() {
      const initOptions = Object.assign({}, this.center, this.initOptions)
      this.map = new mapboxgl.Map({
        container: this.$refs.mapContainer,
        style: {
          version: 8,
          metadata: {},
          sources: {},
          sprite: getSprite(),
          glyphs: getGlyphs(),
          layers: [],
        },
        locale: {
          'FullscreenControl.Enter': 'Mở toàn màn hình',
          'FullscreenControl.Exit': 'Thoát toàn màn hình',
          'GeolocateControl.FindMyLocation': 'Tìm vị trí của tôi',
          'GeolocateControl.LocationNotAvailable': 'Định vị không khả dụng',
          'LogoControl.Title': 'Mapbox logo',
          'NavigationControl.ResetBearing': 'Đặt lại phương vị',
          'NavigationControl.ZoomIn': 'Phóng to',
          'NavigationControl.ZoomOut': 'Thu nhỏ',
          'ScaleControl.Feet': 'ft',
          'ScaleControl.Meters': 'm',
          'ScaleControl.Kilometers': 'km',
          'ScaleControl.Miles': 'mi',
          'ScaleControl.NauticalMiles': 'nm',
        },
        preserveDrawingBuffer: true,
        transformRequest: (url, resourceType) => {
          if (resourceType === 'Tile' && url.includes('api/geoserver')) {
            return {
              url: url,
              headers: { Authorization: 'Bearer ' + getToken() },
            }
          }
        },
        ...initOptions,
      })
      this.map.id = this.id
      setMap(this.id, this.map)
      // this.map.touchZoomRotate.disableRotation()
      // this.map.dragRotate.disable()
      this.map.boxZoom.disable()
      this.map.once('load', () => {
        // Emit for parent component
        this.$emit('map-loaded', this.map)
        this.$nextTick(() => {
          this.loaded = true
          this.map.resize()
        })
      })
    },

    getMap(callback) {
      if (this.loaded) {
        return callback(this.map)
      } else {
        this.$once('map-loaded', () => {
          callback(this.map)
        })
      }
    },

    destroy() {
      this.map.remove()
      this.map = null
    },
    setMinZoom(minZoom) {
      this.map.setMinZoom(minZoom)
    },
  },
}
</script>
<style>
.mapboxgl-ctrl-logo {
  display: none !important;
  visibility: hidden;
}
</style>
<style lang="scss">
.drag-container {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 800;
  width: 100%;
}

.main-map-container {
  pointer-events: none;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > div {
    position: relative;
  }
}

.button-container {
  clear: both;
  pointer-events: auto;
  -webkit-transform: translate(0);
  transform: translate(0);
}

.mapbox-gl-viewer {
  .button-container.button-group-container:not(:first-child) {
    margin-left: 10px;
  }

  .right-bottom-container,
  .right-top-container,
  .left-bottom-container,
  .left-top-container {
    pointer-events: none;
    z-index: 2;
    position: absolute;

    & > * {
      clear: both;
    }
  }

  .right-bottom-container {
    bottom: 0;
    right: 0;

    & > * {
      margin: 0 10px 10px 0;
      float: right;
      clear: both;
    }
  }

  .left-bottom-container {
    bottom: 0;
    left: 0;

    & > * {
      margin: 0 0 10px 10px;
      float: left;
    }
  }

  .left-top-container {
    top: 0;
    left: 0;

    & > * {
      margin: 10px 0 0 10px;
      float: left;
    }
  }

  .right-top-container {
    top: 0;
    right: 0;

    & > * {
      margin: 10px 10px 0 0;
      float: right;
    }
  }
}
</style>
<style scoped>
.mapboxgl-ctrl-logo {
  display: none !important;
  visibility: hidden;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f7f5f2;
}

.not-support-map {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  justify-items: center;
}

.main-container {
  position: relative;
  min-height: 0;
  min-width: 0;
  z-index: 0;
}

.map-viewer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
}

.map-content {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>

<style>
/* Group Control */
.map-container .mapboxgl-ctrl .mapboxgl-ctrl:first-child {
  margin: 0;
}

.map-container .mapboxgl-ctrl .mapboxgl-ctrl:not(:first-child) {
  margin: 10px 0 0 0;
}

/* Map Canvas */
.mapboxgl-canvas:hover,
.mapboxgl-canvas:focus,
.mapboxgl-canvas:active {
  border: none;
  outline: none;
}
</style>
